import { createSlice } from "@reduxjs/toolkit";

export const calendarSlice = createSlice({
  name: "calendar",
  initialState: {
    loadEvents: false,
  },
  reducers: {
    loadEventsAction: (state, action) => {
      state.loadEvents = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { loadEventsAction } = calendarSlice.actions;

export default calendarSlice.reducer;
